import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { shadowSm } from '../../../web/styles/shadows';
import { CALL_LOG_CONTAINER } from './components/styles';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	root: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1fr) auto',
		height: '100%',
		width: '100%',
	},
	// Phones scroll the whole column; the stacked filters would leave the list too little room to scroll on its own.
	pageColumn: {
		height: '100%',
		minWidth: 0,
		overflow: 'hidden',
		[THEME.queries.md]: {
			overflowY: 'auto',
		},
	},
	page: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		margin: '0 auto',
		maxWidth: 1400,
		padding: SPACE[16],
		width: '100%',
		[THEME.queries.md]: {
			height: 'auto',
		},
	},
	content: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
		color: THEME.colors.text.main,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontFamily: fontFamilies.lexend,
		gap: SPACE[20],
		minHeight: 0,
		padding: SPACE[32],
		[THEME.queries.md]: {
			flex: 'none',
		},
		[THEME.queries.sm]: {
			padding: SPACE[16],
		},
	},
	tabs: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minHeight: 0,
		[THEME.queries.md]: {
			flex: 'none',
		},
	},
	title: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	tabContent: {
		containerName: CALL_LOG_CONTAINER,
		containerType: 'inline-size',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: SPACE[16],
		minHeight: 0,
		paddingTop: SPACE[20],
		[THEME.queries.md]: {
			flex: 'none',
		},
	},
	// Radix keeps the inactive panel in the DOM behind `hidden`, which the flex display above would override.
	inactiveTab: {
		display: 'none',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: THEME.common.borderRadius,
		[THEME.queries.md]: {
			borderRadius: 0,
			inset: 0,
			position: 'fixed',
			width: '100%',
			zIndex: 10,
		},
	},
	toolbar: {
		display: 'flex',
		[THEME.queries.md]: {
			display: 'none',
		},
	},
	settingsPanel: {
		padding: SPACE[20],
	},
	settingsPanelTitle: {
		color: THEME.colors.text.light,
		fontSize: fontSizes.sm,
		fontWeight: fontWeights.bold,
		marginBottom: SPACE[8],
		marginTop: 0,
	},
	overlayHeader: {
		display: 'none',
		[THEME.queries.md]: {
			display: 'flex',
			justifyContent: 'flex-end',
			padding: SPACE[8],
		},
	},
});
